import React, { useRef } from "react";
import ReactDOM from "react-dom/client";
import dynamic from "next/dynamic";
import useModalController from "../useModalController";

// components
const ModalWrapper = dynamic(() => import("../../components/modal-wrapper"));

function useModal() {
  const root = useRef(null);
  const [onModalDisplay, onModalClose] = useModalController();

  const unmountModal = () => {
    if (root.current) {
      root.current.unmount();
      root.current = null;
    }
  };

  const renderModal = ({ Component, config, props }) => {
    if (!config?.rootId || !Component) return;

    if (!root.current) {
      root.current = ReactDOM.createRoot(
        document.getElementById(config.rootId)
      );
    }

    root.current.render(
      <ModalWrapper>
        <Component {...props} onCloseModal={() => closeModal(config)} />
      </ModalWrapper>
    );
  };

  // CONTROLLERS
  const closeModal = (config) => {
    unmountModal();
    onModalClose(config);
  };

  const displayModal = ({ props, config, Component }) => {
    const { displayConfig, type } = config;
    const shouldDisplay = onModalDisplay(type, displayConfig);

    if (shouldDisplay) renderModal({ props, config, Component });
  };

  return displayModal;
}

export default useModal;
